import React, { useState, useEffect, useRef, useMemo } from 'react';
import TopBannerBox from '../../../components/box/TopBannerBox';
import MedicRecordBox from '../../../components/box/MedicRecordBox';
//import EmotionRecordBox from '../../../components/box/EmotionRecordBox';
import HealthRecordBox from '../../../components/box/HealthRecordBox';
import Modal from '../../../components/comm/Modal';
import ToastPopup from '../../../components/comm/ToastPopup';
import dayjs from 'dayjs';

import { Link, useNavigate, useLocation } from 'react-router-dom';
import URL from '../../../constants/url';
import style from './HomeTodo.module.css';
import Skeleton from '@mui/material/Skeleton';

//swiper
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

// 탭 UI
import { Tab } from '@mui/base/Tab';
import { TabsList } from '@mui/base/TabsList';
import { TabPanel } from '@mui/base/TabPanel';
import { Tabs } from '@mui/base/Tabs';

import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import congratsLottie from "../../../assets/lottiefiles/congrats.lottie";

//설문
import data_01 from './survey/01/data_01.json';
import data_02 from './survey/02/data_02.json';
import data_03 from './survey/03/data_03.json';
import data_04 from './survey/04/data_04.json';
import data_05 from './survey/05/data_05.json';
import data_06 from './survey/06/data_06.json';
import data_07 from './survey/07/data_07.json';
import data_08 from './survey/08/data_08.json';
import data_09 from './survey/09/data_09.json';
import data_10 from './survey/10/data_10.json';
import data_11 from './survey/11/data_11.json';
import data_15 from './survey/15/data_15.json';
import data_16 from './survey/16/data_16.json';
import data_17 from './survey/17/data_17.json';
import data_18 from './survey/18/data_18.json';
import data_19 from './survey/19/data_19.json';
import data_20 from './survey/20/data_20.json';
import data_21 from './survey/21/data_21.json';
import data_22 from './survey/22/data_22.json';
import data_23 from './survey/23/data_23.json';
import data_24 from './survey/24/data_24.json';
import data_25 from './survey/25/data_25.json';
import data_26 from './survey/26/data_26.json';
import data_27 from './survey/27/data_27.json';
import data_28 from './survey/28/data_28.json';


import axiosApi from '../../../api/daonAxios';
import CODE from '../../../constants/code';
import ConfirmBox from '../../../components/box/ConfirmBox';

//import { formatDateToYYMMDD, getDayKoreanLetter } from '../../../hook/dateUtils';

//공지사항 팝업
import NoticePopup from '../../../components/comm/NoticePopup';


//미답변 설문 리스트 자동 생성 (TODO: key값은 하드코딩. 로컬 DB에 따라 셋팅필요)
    const surveyDataMap = {
        0: { url: URL.SURVEY_CUSTOM }, // 맞춤설문
        1: { data: data_01, url: URL.SURVEY_01 },
        2: { data: data_02, url: URL.SURVEY_02 },
        6: { data: data_03, url: URL.SURVEY_03 },
        4: { data: data_04, url: URL.SURVEY_04 },
        5: { data: data_05, url: URL.SURVEY_05 },
        7: { data: data_06, url: URL.SURVEY_06 },
        8: { data: data_07, url: URL.SURVEY_07 },
        9: { data: data_08, url: URL.SURVEY_08 },
        10: { data: data_09, url: URL.SURVEY_09 },
        11: { data: data_10, url: URL.SURVEY_10 },
        14: { data: data_11, url: URL.SURVEY_11 },
        15: { data: data_15, url: URL.SURVEY_15 },
        16: { data: data_16, url: URL.SURVEY_16 },
        17: { data: data_17, url: URL.SURVEY_17 },
        18: { data: data_18, url: URL.SURVEY_18 },
        19: { data: data_19, url: URL.SURVEY_19 },
        20: { data: data_20, url: URL.SURVEY_20 },
        21: { data: data_21, url: URL.SURVEY_21 },
        22: { data: data_22, url: URL.SURVEY_22 },
        23: { data: data_23, url: URL.SURVEY_23 },
        24: { data: data_24, url: URL.SURVEY_24 },
        25: { data: data_25, url: URL.SURVEY_25 },
        26: { data: data_26, url: URL.SURVEY_26 },
        27: { data: data_27, url: URL.SURVEY_27 },
        28: { data: data_28, url: URL.SURVEY_28 },
    };

const HomeTodo = ({ onNavigateToGuide }) => {

    const hasRequestedPermission = useRef(false);
    const mountedRef = useRef(false);
    const navigate = useNavigate();
    const location = useLocation();

    /********************** useState **********************/
    const [isPillCancelOpen, setIsPillCancelOpen] = useState(false);
    const [pendingUncheck, setPendingUncheck] = useState({ index: null, notificationId: null });

    const fetchedRef = useRef(false);

    const [confirmModal, setConfirmModal] = useState({ open: false, mode: null });
    const [value, setValue] = useState(() => {
        // 숫자로 직접 오는 경우
        if (typeof location.state?.tabIndex === 'number') {
            return location.state.tabIndex;
        }

        // 문자열 탭 이름으로 오는 경우 (알림에서 이동 시)
        if (location.state?.tab) {
            const tabMap = {
                'medication': 0,
                'health-record': 1
            };
            return tabMap[location.state.tab] ?? 0;
        }

        return Number(sessionStorage.getItem('homeTodoTab')) || 0;
    });

    const [toast, setToast] = useState(false);

    const [swiper, setSwiper] = useState(null);
    const paginationRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [recordOpen, setRecordOpen] = useState(false);

    const [takingMedicineList, setTakingMedicineList] = useState([]); //복약기록
    const [notifications, setNotifications] = useState([]);
    const [surveyOnceResultList, setSurveyOnceResultList] = useState([]); //건강기록 단발성
    const [surveyPrdcResultList, setSurveyPrdcResultList] = useState([]); //건강기록 연속성

    const today = new Date();
    const todayStr = dayjs(today).format("YYYYMMDD");
    const todayNotifications = notifications;

    // 2. 상태 추가
    const [isLoadingMedicine, setIsLoadingMedicine] = useState(true);


    const [pendingAlarms, setPendingAlarms] = useState([]);

    //공시사항 팝업 //
    const [showNotice, setShowNotice] = useState( false
        //() => sessionStorage.getItem('noticeClosed') !== 'true'
    );


    /**
     * 작성완료 여부 체크
     * @param surveyResultList
     * @param srveyMngId
     * @returns {boolean}
     */
    const checkWrite = (surveyResultList, srveyMngId) => {
        const survey = surveyResultList.find(result => result.srveyMngId === srveyMngId);
        return survey?.lastMarkVal != null;
    };


    /********************** useEffect **********************/
    useEffect(() => {
        if (location.state?.tabIndex !== undefined) {
            setValue(location.state.tabIndex);
            sessionStorage.setItem('homeTodoTab', location.state.tabIndex);
        } else if (location.state?.tab) {
            const tabMap = {
                'medication': 0,
                'health-record': 1
            };
            const targetTab = tabMap[location.state.tab] ?? 0;
            setValue(targetTab);
            sessionStorage.setItem('homeTodoTab', targetTab);
        }
    }, [location.state]);

    useEffect(() => {
        fetchMedicationAlarms();
    }, []);

    useEffect(() => {
        if (
            notifications.length > 0 &&
            notifications.every(notif => notif.tkmdcnAt === '1') &&
            sessionStorage.getItem('toastShown') !== 'true'
        ) {
            setToast(true);
            sessionStorage.setItem('toastShown', 'true');
        }
    }, [notifications]);



    useEffect(() => {
        if (fetchedRef.current) return;
        fetchedRef.current = true;
        searchSurveyResultList(setSurveyOnceResultList, "A");
        searchSurveyResultList(setSurveyPrdcResultList);
        getNativAlrmPermission();
        searchTakingMedicineRecordList();
    }, []);

    useEffect(() => {
        const handleFocus = () => {
            if (!mountedRef.current) return;
            console.log('🔄 포커스 복귀 - 알림 갱신');
            searchTakingMedicineRecordList();
        };

        window.addEventListener('focus', handleFocus);
        return () => window.removeEventListener('focus', handleFocus);
    }, []);

    useEffect(() => {
        if (!swiper || !paginationRef.current) return;

        const bullets = paginationRef.current.querySelectorAll('span');
        const handlers = [];

        bullets.forEach((bullet, index) => {
            const handler = () => {
                swiper.slideTo(index);
                const slideEl = swiper.slides[index];
                if (slideEl) {
                    slideEl.focus();
                }
            };
            handlers.push(handler);
            bullet.addEventListener('click', handler);
        });

        return () => {
            bullets.forEach((bullet, index) => {
                bullet.removeEventListener('click', handlers[index]);
            });
        };
    }, [swiper]);

   // API
    const fetchMedicationAlarms = async () => {
        const user = JSON.parse(sessionStorage.getItem("loginUser"));
        const jToken = localStorage.getItem("jToken");

        try {
            const res = await axiosApi.post("/notifications/medication-list", {
                usrInfoId: user?.usrInfoId,
                page: 0,
                size: 100
            }, {
                headers: { "Authorization": `Bearer ${jToken}` }
            });

            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setPendingAlarms(res.data.result?.notifications || []);
            }
        } catch (err) {
            console.error("알림 목록 조회 실패", err);
        }
    };

    const handleAlarmDismiss = async (alarmId) => {
        const jToken = localStorage.getItem("jToken");

        try {
            const res = await axiosApi.post("/notifications/medication-read", {
                id: alarmId
            }, {
                headers: { "Authorization": `Bearer ${jToken}` }
            });

            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setPendingAlarms(prev => prev.filter(item => item.id !== alarmId));
            }
        } catch (err) {
            console.error("알림 확인 처리 실패", err);
        }
    };

    const handleAlarmNavigate = async (alarm) => {
        const jToken = localStorage.getItem("jToken");

        // cnfrm_at 업데이트
        try {
            await axiosApi.post("/notifications/medication-read", {
                id: alarm.id
            }, {
                headers: { "Authorization": `Bearer ${jToken}` }
            });
        } catch (err) {
            console.error("알림 확인 처리 실패", err);
        }

        setPendingAlarms(prev => prev.filter(item => item.id !== alarm.id));

        // 복약처방(10) → RecordSettingDetail 이동
        if (alarm.alrmTmplatId === '10') {
            try {
                const paramData = JSON.parse(alarm.cnncPrmtrVal);
                navigate(URL.RECORD_SETTING_DETAIL, {
                    state: {
                        paramData,
                        item: {
                            hsptlCd: paramData.hsptlCd,
                            patntId: paramData.patntId,
                            deptCd: paramData.deptCd,
                            prscrptnDt: paramData.prscrptnDt
                        }
                    }
                });
            } catch (e) {
                console.error("cnncPrmtrVal 파싱 실패", e);
            }
            return;
        }

        // 재택치료가이드(7) → 탭2 이동
        if (alarm.alrmTmplatId === '7' && onNavigateToGuide) {
            onNavigateToGuide();
        }
    };


    const memoSurveyData = useMemo(
        () => surveyOnceResultList
            .filter(survey => !checkWrite(surveyOnceResultList, survey.srveyMngId))
            .map(survey => {
                //console.log( " =========> memoSurveyData survey : ", survey );
                let srveyJson = {};
                //고정:05 /맞춤:06
                if(survey.cntsSeCd === '05') {
                    const mapped = surveyDataMap[survey.srveyMngId];
                    srveyJson = { ...mapped.data[0], url: mapped.url, item: survey } || {};
                } else if(survey.cntsSeCd === '06') {
                    srveyJson = { url: surveyDataMap[0].url, item: survey } || {};
                }
                if (!srveyJson.url) return null;
                return srveyJson;
            })
            .filter(Boolean),
        [surveyOnceResultList]
    );

    const memoHealthDataList = useMemo(
        () => surveyPrdcResultList.map(survey => {
            let srveyJson = {};
            //고정:05 /맞춤:06
            if(survey.cntsSeCd === '05') {
                const mapped = surveyDataMap[survey.srveyMngId];
                srveyJson = { ...mapped.data[0], url: mapped.url, item: survey } || {};
            } else if(survey.cntsSeCd === '06') {
                srveyJson = { url: surveyDataMap[0].url, item: survey } || {};
            }
            if (!srveyJson.url) return null;
            return srveyJson;
        }),
        [surveyPrdcResultList]
    );


    /********************** API **********************/
    // 사용자 복약 기록 목록 조회
    const searchTakingMedicineRecordList = () => {
        const user = JSON.parse(sessionStorage.getItem("loginUser"));
        const requestUrl = "/homecare/tkmdcn/retrieveUserTakingMedicineRecordingList";
        const jToken = localStorage.getItem("jToken");
        const today = dayjs().format("YYYYMMDD");

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        };

        const requestBody = {
            usrInfoId: user?.usrInfoId,
            usrHsptlMap: user?.usrHsptlMap
        };
        setIsLoadingMedicine(true); // 로딩 시작

        axiosApi.post(requestUrl, requestBody, requestOption)
            .then((res) => {
                //console.log( "========================> searchTakingMedicineRecordList res: : ", res );
                const resultData = res.data;

                if (resultData.resultCode === CODE.RCV_SUCCESS) {
                    const allData = resultData.result.usrTkmdcnRecList || [];

                    const transformedList = allData
                        .filter(item => item.tkmdcnEndDe >= today)
                        .map(item => {
                            const hour = item.alrmSetupTm ? parseInt(item.alrmSetupTm.substring(0, 2), 10) : 9;
                            const minute = item.alrmSetupTm ? parseInt(item.alrmSetupTm.substring(2, 4), 10) : 0;
                            const pillList = item.tkmdcnCn ? item.tkmdcnCn.split('@,@') : [];

                            return {
                                id: `${item.tkmdcnGrpCd}_${item.tkmdcnEraCd}`,
                                hour,
                                minute,
                                active: item.alrmAt === '1' ? 'Y' : 'N',
                                status: item.tkmdcnAt === '1' ? 'completed' : 'pending',
                                data: {
                                    data: {
                                        selectedTime: item.tkmdcnEraNm,
                                        timing: item.tkmdcnMthCn || '',
                                        pillList: pillList
                                    }
                                },
                                body: item.tkmdcnCn,
                                // 서버 데이터 전부 저장
                                ...item
                            };
                        });

                    setNotifications(transformedList);
                    setTakingMedicineList(allData);
                } else {
                    setNotifications([]);
                    setTakingMedicineList([]);
                }
                setIsLoadingMedicine(false); // 로딩 완료
            })
            .catch((err) => {
                console.log("=========> err : ", err);
                setNotifications([]);
                setTakingMedicineList([]);
                setIsLoadingMedicine(false); // 로딩 완료
            });
    };

    // 사용자 복약 기록 저장
    const handleConfirm = async () => {
        const mode = confirmModal.mode;
        const newStatus = mode === "checkAll" ? 'completed' : 'pending';
        const newCheckedList = Array(todayNotifications.length).fill(mode === "checkAll");

        if (mode === "checkAll") {
            const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
            const jToken = localStorage.getItem("jToken");
            const today = dayjs().format("YYYYMMDD");
            const url = "/homecare/tkmdcn/saveUserTakingMedicineRecordList";

            const reqBody = todayNotifications.map(notif => ({
                usrTkmedicnInfoId: notif.usrTkmedicnInfoId,
                usrInfoId: loginUser.usrInfoId,
                tkmdcnDe: today
            }));

            const reqOptions = {
                headers: {
                    'Authorization': 'Bearer ' + jToken,
                }
            };

            try {
                const res = await axiosApi.post(url, reqBody, reqOptions);

                if (res.data.resultCode !== CODE.RCV_SUCCESS) {
                    alert("복약 기록 저장에 실패했습니다.");
                    setConfirmModal({ open: false, mode: null });
                    return;
                }

                searchTakingMedicineRecordList();  // 성공 시 리스트 재조회
            } catch (err) {
                console.error("복약 기록 저장 중 오류", err);
                alert("복약 기록 저장에 실패했습니다.");
                setConfirmModal({ open: false, mode: null });
                return;
            }
        }

        if (mode === "uncheckAll") {
            sessionStorage.removeItem('toastShown');
            searchTakingMedicineRecordList();  // 취소 시에도 리스트 재조회
        }

        setConfirmModal({ open: false, mode: null });
    };
    /********************** event **********************/

    const handleSingleCheck = async (usrTkmedicnInfoId, isChecked) => {
        if (!isChecked) {
            // 이미 복약이 완료 되었으면 취소 불가
            // setPendingUncheck({ usrTkmedicnInfoId });
            // setIsPillCancelOpen(true);
            return;
        }

        const success = await updateMedicineStatus(usrTkmedicnInfoId, '1');

        if (!success) {
            alert("복약 기록 저장에 실패했습니다.");
        } else {
            if (window.ReactNativeWebView) {
                window.ReactNativeWebView?.postMessage(JSON.stringify({
                    type: 'SHOW_TOAST',
                    message: '복약 완료 !'
                }));
            }
        }
    };

    const handleConfirmDelete = async (e) => {
        if (!e) {
            setIsPillCancelOpen(false);
            setPendingUncheck({ usrTkmedicnInfoId: null });
            return;
        }

        const { usrTkmedicnInfoId } = pendingUncheck;

        const success = await updateMedicineStatus(usrTkmedicnInfoId, '0');

        if (!success) {
            alert("복약 기록 취소에 실패했습니다.");
        } else {
            sessionStorage.removeItem('toastShown');
        }

        setPendingUncheck({ usrTkmedicnInfoId: null });
        setIsPillCancelOpen(false);
    };

    const handleAllCheckClick = () => {
        const allChecked = notifications.length > 0 && notifications.every(notif => notif.tkmdcnAt === '1');

        if (allChecked) {
            // setConfirmModal({ open: true, mode: "uncheckAll" });
        } else {
            setConfirmModal({ open: true, mode: "checkAll" });
        }
    };

    // 사용자 건강기록(설문조사) 리스트 조회 (신)
    const searchSurveyResultList = async (setResultList, recGbnVal = "BC") => {
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));

        const url = "/homecare/srvey/retrieveUserHealthRecordsList"
        const jToken = localStorage.getItem('jToken');
        const reqBody = {
            usrHsptlMap: loginUser.usrHsptlMap
            , recGbnVal: recGbnVal
        };
        const reqOptions = {
            headers: {
                'Authorization': 'Bearer ' + jToken,
            }
        };
        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            const resultList = res.data.result.resultList || [];
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setResultList(resultList);
            } else {
                setResultList([]);
            }

        } catch (err) {
            console.error("결과 조회 중 오류", err);
        }
    };



    const meal_to_num = (meal) => {
        let result;

        switch (meal) {
            case '아침': result = '1'
                break;
            case '점심': result = '2'
                break;
            case '저녁': result = '3'
                break;
            default:
                break;
        }

        return result;
    }

    const getNativAlrmPermission = () => {
        if (hasRequestedPermission.current) {
            return;
        }

        hasRequestedPermission.current = true;

        if (window.ReactNativeWebView) {
            window.ReactNativeWebView?.postMessage(
                JSON.stringify({ type: 'REQUEST_NOTIFICATION_PERMISSION' })
            );
        }
    };


    const getHealthRemainingCount = () => {
        let remainCnt = 0;
        if (surveyPrdcResultList.length > 0) {
            remainCnt = surveyPrdcResultList.filter(item => item.lastMarkVal === undefined).length;
        }
        return remainCnt;
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
        sessionStorage.setItem('homeTodoTab', newValue);
    };

    const updateMedicineStatus = async (usrTkmedicnInfoId, tkmdcnAt) => {
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
        const jToken = localStorage.getItem("jToken");
        const today = dayjs().format("YYYYMMDD");

        const url = "/homecare/tkmdcn/saveUserTakingMedicineRecordList";

        const reqBody = [
            {
                usrTkmedicnInfoId: usrTkmedicnInfoId,
                usrInfoId: loginUser.usrInfoId,
                tkmdcnDe: today
            }
        ];

        const reqOptions = {
            headers: {
                'Authorization': 'Bearer ' + jToken,
            }
        };

        console.log('reqBody:', reqBody);
        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);

            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                console.log("복약 상태 업데이트 성공");
                searchTakingMedicineRecordList();  // 리스트 재조회
                return true;
            } else {
                console.warn("복약 상태 업데이트 실패:", res.data.resultMessage);
                return false;
            }
        } catch (err) {
            console.error("복약 상태 업데이트 중 오류", err);
            return false;
        }
    };


    // 1. 시간대 우선순위 매핑 함수
    const getTimePriority = (selectedTime) => {
        const timeMap = {
            '아침': 1,
            '점심': 2,
            '저녁': 3,
            '취침전': 4
        };
        return timeMap[selectedTime] || 999; // 매칭 안되면 맨 뒤로
    };

    // 2. 정렬된 notifications를 반환하는 useMemo
    const sortedNotifications = useMemo(() => {
        return [...todayNotifications].sort((a, b) => {
            // 1차: 시간대 우선순위 (아침 > 점심 > 저녁 > 취침전)
            const timePriorityA = getTimePriority(a?.data?.data?.selectedTime);
            const timePriorityB = getTimePriority(b?.data?.data?.selectedTime);

            if (timePriorityA !== timePriorityB) {
                return timePriorityA - timePriorityB;
            }

            // 2차: 처방일시 (tkmdcnBgngDe) 빠른 순
            const dateA = a.tkmdcnBgngDe || '99999999';
            const dateB = b.tkmdcnBgngDe || '99999999';

            return dateA.localeCompare(dateB);
        });
    }, [todayNotifications]);



    return (
        <>

            {/* 공지 팝업 */}
            {showNotice && (
                <NoticePopup
                    visible={showNotice}
                    onClose={() => {
                        sessionStorage.setItem('noticeClosed', 'true');
                        setShowNotice(false);
                    }}
                    title={"서버 점검으로 인해 일부 서비스 이용이\n일시적으로 제한됩니다."}
                    maintenanceTime="오후 6시 ~ 오후 8시 예정"
                    duration="약 2시간 소요"
                    description={"이용에 불편을 드려 죄송합니다."}
                    descriptionSub={"(영향 받는 서비스 : 병원케어, 환자정보 등)"}
                />
            )}

            <div id="home-todo" className='inner-wrap'>
                <div className='to-do-box'>

                    <div className={style['top-banner-wrap']}>
                        <TopBannerBox type="typeA" />
                    </div>

                    <div
                        className={style['pre-question-wrap']}
                        style={{
                            height: memoSurveyData.length > 1 ? 'var(--sp-122)' : memoSurveyData.length === 1 ? 'var(--sp-105)' : '0',
                            marginTop: memoSurveyData.length > 0 ? '30px' : '0',
                            overflow: 'hidden',
                            transition: 'height 0.4s ease'
                        }}>
                        <Swiper
                            modules={[Navigation, Pagination, Scrollbar, A11y]}
                            a11y={{
                                prevSlideMessage: '이전 설문 보기',
                                nextSlideMessage: '다음 설문 보기',
                                paginationBulletMessage: '설문 슬라이드 {{index}} 보기'
                            }}
                            navigation={{
                                prevEl: '.swiper-button-prev',
                                nextEl: '.swiper-button-next'
                            }}
                            spaceBetween={50}
                            slidesPerView={1}
                            onBeforeInit={(swipper) => setSwiper(swipper)}
                            pagination={{
                                el: paginationRef.current,
                                clickable: true,
                            }}
                        >
                            {memoSurveyData.map((data, idx) => (
                                <SwiperSlide key={idx} tabIndex={0}>
                                    <div
                                        className={style['pre-question-box']}
                                        onClick={() => navigate(data.url, { state: { item: data.item } })}
                                        tabIndex={0}
                                        aria-label={`${idx + 1}번짜 설문지 작성 시간 ${data.item?.reqreTmCn}, 설문 제목 ${data.item?.srveySj}, 설문병원 ${data.item?.insttNm}, 설문 과 ${data.item?.cnncDeptNm}`}
                                    >
                                        <div className={style['top-box']}>
                                            <span aria-hidden='true'>{data.item?.reqreTmCn}</span>
                                            <button aria-hidden='true'>
                                                <span>작성하기</span>
                                            </button>
                                        </div>
                                        <p className={style['tit']} aria-hidden='true'>{data.item?.srveySj}</p>
                                        <p className={style['span-group']} aria-hidden='true'>
                                            <span>{data.item?.srveySj}</span>
                                            <span>{data.item?.cnncDeptNm}</span>
                                        </p>
                                    </div>
                                </SwiperSlide>
                            ))}

                        </Swiper>
                        <div className="swiper-custom-pagination" aria-hidden="true" ref={paginationRef}></div>

                    </div>

                    {pendingAlarms.length > 0 && (() => {
                        const current = pendingAlarms[0];
                        return (
                            <div className={style['record-setting-box']}>
                                <div className={style['inner-box']}>
                                    <div className={style['left']}>
                                        <p>
                                            {current.alrmSj}

                                            {/* {pendingAlarms.length > 1 && (
                                                <> <b>외 {pendingAlarms.length - 1}건</b></>
                                            )} */}

                                            <br />
                                            <b>{current.alrmCn}</b>
                                        </p>
                                    </div>
                                    <div className={style['right']}>
                                        <button
                                            className={style['setting-btn']}
                                            onClick={() => handleAlarmNavigate(current)}
                                        >
                                            <span>이동하기</span>
                                        </button>
                                        <button
                                            className={style['cancel-box']}
                                            onClick={() => handleAlarmDismiss(current.id)}
                                            aria-label="알림 확인"
                                        >
                                            <span></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })()}



                    <div className={style['tabs-box']}>
                        <Tabs value={value} onChange={handleChange} orientation="vertical">
                            <div className="top-tab-head" data-type="c">
                                <TabsList>
                                    <Tab
                                        value={0}
                                        disableRipple
                                    >복약 기록
                                        {todayNotifications?.filter(notif => notif.tkmdcnAt !== '1').length > 0 &&
                                            <span className='badge' aria-label="오늘 복약 기록 개수">
                                                {todayNotifications.filter(notif => notif.tkmdcnAt !== '1').length}
                                            </span>
                                        }
                                    </Tab>

                                    <Tab
                                        value={1}
                                        disableRipple
                                    >건강 기록
                                        {surveyPrdcResultList?.length > 0 && getHealthRemainingCount() > 0 &&
                                            <span className='badge' aria-label="오늘 건강 기록 개수">{getHealthRemainingCount()}</span>
                                        }
                                    </Tab>

                                </TabsList>
                            </div>

                            <TabPanel value={0} className={style['tab-panel-box']}>
                                <div className="record-head-title">
                                    <div className="record-tit">
                                        <strong aria-label={`복약 기록 총 ${notifications?.length} 건`} >총 <span>{notifications?.length}</span>건</strong>
                                        <button className='alarm-setting-btn' onClick={() => navigate(URL.PILL_ALARM)}>
                                            <span>알림설정</span>
                                        </button>
                                    </div>

                                    {(value == 0 && todayNotifications.length > 0 && !isLoadingMedicine) &&
                                        <div className="chkbox-custom" data-chkbox="all-btn">
                                            <input
                                                type="checkbox"
                                                id="all-btn"
                                                checked={notifications.length > 0 && notifications.every(notif => notif.tkmdcnAt === '1')}
                                                onChange={handleAllCheckClick}
                                            />
                                            <label htmlFor="all-btn">모두 완료</label>
                                        </div>
                                    }
                                </div>

                                {/* 로딩 중 스켈레톤 */}
                                {isLoadingMedicine && (
                                    <>
                                        {[...Array(3)].map((_, idx) => (
                                            <div key={'skeleton_medic_' + idx} style={{
                                                padding: '8px 16px',
                                                marginTop: '16px',
                                                backgroundColor: '#fff',
                                                borderRadius: '12px'
                                            }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                                                    <div style={{ flex: 1 }}>
                                                        <Skeleton variant="text" width="200px" height={24} style={{ marginBottom: '4px' }} />
                                                        <Skeleton variant="text" width="120px" height={18} />
                                                        <Skeleton variant="text" width="100px" height={16} />
                                                    </div>
                                                    {/* <div style={{ display:'flex', gap: '10px'}}>
                                                        <Skeleton variant="circular" width={24} height={24} />
                                                        <Skeleton variant="circular" width={24} height={24}/>
                                                    </div> */}
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                )}

                                {/* 데이터 없을 때 */}
                                {!isLoadingMedicine && todayNotifications && todayNotifications.length < 1 &&
                                    <div className={style['medic-record-empty']}>
                                        <div className={style['inner-box']}>
                                            <p>오늘은 복약 기록 일정이 없습니다.</p>
                                            <button className='btn' data-btn-size="sm" data-btn-type="fill-main" data-btn-icon='arrow' onClick={() => navigate(URL.CALENDER)} >
                                                <span>복약 기록 전체 일정</span>
                                            </button>
                                        </div>
                                    </div>
                                }

                                {/* {!isLoadingMedicine && todayNotifications?.map((item, index) => (
                                    <MedicRecordBox
                                        // key={item.id}

                                        key={item.usrTkmedicnInfoId || `medic_${index}`}
                                        item={item}
                                        index={index}
                                        pillName="처방 외 복용하는"
                                        chkDay={meal_to_num(item?.data?.data?.selectedTime)}
                                        pillType="user"
                                        checked={item.tkmdcnAt === '1'}
                                        onCheckChange={handleSingleCheck}
                                        setNotifications={setNotifications}
                                    />
                                ))} */}

                                {!isLoadingMedicine && sortedNotifications?.map((item, index) => (
                                    <MedicRecordBox
                                        key={item.id}
                                        item={item}
                                        index={index}
                                        pillName="처방 외 복용하는"
                                        chkDay={meal_to_num(item?.data?.data?.selectedTime)}
                                        pillType="user"
                                        checked={item.tkmdcnAt === '1'}
                                        onCheckChange={handleSingleCheck}
                                        setNotifications={setNotifications}
                                    />
                                ))}

                                <div className={style['record-more-box']}>
                                    <Link
                                        to={URL.PILL_ADD}
                                        className={style['more-btn']}
                                        draggable={false}
                                    >
                                        복약 추가하기
                                    </Link>
                                </div>
                            </TabPanel>

                            <TabPanel value={1} className={style['tab-panel-box']}>
                                <div className="record-head-title">
                                    <div className="record-tit">
                                        <strong>총 <span>{surveyPrdcResultList.length}</span>건</strong>
                                        <button className='alarm-setting-btn' onClick={() => navigate(URL.HEALTH_ALARM)}>
                                            <span>알림설정</span>
                                        </button>
                                    </div>
                                </div>

                                {/* 로딩 중 스켈레톤 */}
                                {isLoadingMedicine && (
                                    <>
                                        {[...Array(3)].map((_, idx) => (
                                            <div key={'skeleton_medic_' + idx} style={{
                                                padding: '8px 16px',
                                                marginTop: '16px',
                                                backgroundColor: '#fff',
                                                borderRadius: '12px'
                                            }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                                                    <div style={{ flex: 1 }}>
                                                        <Skeleton variant="text" width="200px" height={24} style={{ marginBottom: '4px' }} />
                                                        <Skeleton variant="text" width="120px" height={18} />
                                                        <Skeleton variant="text" width="100px" height={16} />
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                )}

                                {memoHealthDataList.length > 0 &&
                                    memoHealthDataList.map((data, index) => {
                                        return (
                                            <HealthRecordBox
                                                key={data?.item?.usrSrveyRsltId}
                                                title={data?.item?.srveySj}
                                                write={checkWrite(surveyPrdcResultList, data?.item?.srveyMngId)}
                                                usrSrveyRsltId={data?.item?.usrSrveyRsltId}
                                                date={dayjs().format("YYYYMMDD")}
                                                surveyData={data}
                                                alarmChk={data?.item?.alrmAt}
                                            />
                                        );
                                    })
                                }

                                <div className={style['other-record-wrap']}>
                                    <ul>
                                        <li>
                                            <Link
                                                to={URL.STEPS_MAIN}
                                                data-icon="1"
                                                draggable={false}
                                            >
                                                <span>걸음수 기록</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to={URL.BODY_MASS_RECORD}
                                                data-icon="2"
                                                draggable={false}
                                            >
                                                <span>체질량 기록</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to={URL.BLOOD_PRESSURE_RECORD}
                                                data-icon="3"
                                                draggable={false}
                                            >
                                                <span>혈압 기록</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to={URL.BLOOD_SUGAR_RECORD}
                                                data-icon="4"
                                                draggable={false}
                                            >
                                                <span>혈당 기록</span>
                                            </Link>
                                        </li>
                                        {/* 연구 항목임.. 운영에는 노출되지 않도록 조정.
                                        <li>
                                            <button
                                                data-icon="5"
                                                data-list-type='btn'
                                                onClick={() => {
                                                    if (window.ReactNativeWebView) {
                                                        window.ReactNativeWebView.postMessage(JSON.stringify({
                                                            type: 'LAUNCH_APP',
                                                            payload: {
                                                                android: { scheme: 'iitpapp://diet', storeUrl: 'about:blank' },
                                                                ios:     { scheme: 'iitpapp://diet', storeUrl: 'about:blank' },
                                                            },
                                                        }));
                                                    }
                                                }}
                                            >
                                                <span>식단 관리</span>
                                            </button>
                                        </li>

                                        <li>
                                            <button
                                                data-icon="6"
                                                data-list-type='btn'
                                                onClick={() => {
                                                    if (window.ReactNativeWebView) {
                                                        window.ReactNativeWebView.postMessage(JSON.stringify({
                                                            type: 'LAUNCH_APP',
                                                            payload: {
                                                                android: { scheme: 'iitpapp://body-check', storeUrl: 'about:blank' },
                                                                ios:     { scheme: 'iitpapp://body-check', storeUrl: 'about:blank' },
                                                            },
                                                        }));
                                                    }
                                                }}
                                            >
                                                <span>인바디</span>
                                            </button>
                                        </li>
                                        */}
                                    </ul>
                                </div>

                            </TabPanel>

                        </Tabs>
                    </div>

                </div>

                <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
                    <div className='modal-box' data-type="a">
                        <div className='modal-top-box'>
                            <div className='title-box'>
                                <p> 삭제하면 다시 노출되지 않습니다.</p>
                                <p> 삭제하시겠습니까? </p>
                            </div>
                            <div className='sub-box'>
                                <span>전체메뉴 &gt; 앱 설정 &gt; 기록 설정에서 <br /> 확인 가능합니다.</span>
                            </div>
                        </div>

                        <div className="modal-bottom-box">
                            <div className='btn-layout'>
                                <button className="btn" data-btn-type="outline-main" data-btn-size="md" onClick={() => setIsOpen(false)}>
                                    <span>취소</span>
                                </button>
                                <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={() => { setRecordOpen(false); setIsOpen(false) }}>
                                    <span>삭제</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

            </div>

            {toast && (
                <>
                    <ToastPopup
                        setToast={setToast}
                        message={'오늘 복약 모두 완료!'}
                        position="center"
                        opacity="90"
                    />
                    <div className='lottie-box'>
                        <DotLottieReact
                            src={congratsLottie}
                            loop
                            autoplay
                        />
                    </div>
                </>
            )}

            <Modal isOpen={confirmModal.open} setIsOpen={() => setConfirmModal({ open: false, mode: null })}>
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            {confirmModal.mode === "checkAll" ? (
                                <p>복약을 모두 완료하셨나요?</p>
                            ) : (
                                <p>복약 기록을 모두 취소하시겠어요?</p>
                            )}
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button
                                className="btn"
                                data-btn-type="outline-main"
                                data-btn-size="md"
                                onClick={() => setConfirmModal({ open: false, mode: null })}
                            >
                                <span>아니오</span>
                            </button>
                            <button
                                className="btn"
                                data-btn-type="fill-main"
                                data-btn-size="md"
                                onClick={handleConfirm}
                            >
                                <span>
                                    {confirmModal.mode === "checkAll" ? "네,완료했어요" : "네,취소할께요"}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            <ConfirmBox isOpen={isPillCancelOpen}
                setIsOpen={setIsPillCancelOpen}
                onCloseCallback={handleConfirmDelete}
                message={
                    <>
                        복약 기록을 취소하시겠어요?
                    </>
                }
                leftBtnTxt={'아니오'}
                rightBtnTxt={'네, 취소할게요'}
            />

        </>
    );
};

export default HomeTodo;
